// import React, { useState, useEffect } from "react";
// import toast from "react-hot-toast";
// import { useNavigate, useParams } from "react-router-dom";
// import equipmentService from "../../../Services/inventoryService";

// // ── Reusable components ──────────────────────────────────────
// const SectionLabel = ({ children }) => (
//   <p className="text-[11px] uppercase tracking-widest font-[500] text-gray-400 mb-3 mt-6">
//     {children}
//   </p>
// );

// const InputField = ({ label, prefix, ...props }) => (
//   <div className="flex flex-col gap-1">
//     <label className="text-[12px] font-[500] text-gray-500">{label}</label>
//     <div className="relative">
//       {prefix && (
//         <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[12px] text-gray-400">
//           {prefix}
//         </span>
//       )}
//       <input
//         {...props}
//         className={`w-full ${prefix ? "pl-8" : "px-3"} pr-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none hover:border-orange-200 focus:border-orange-400 focus:ring-2 focus:ring-orange-100`}
//       />
//     </div>
//   </div>
// );

// // ── Main Component ───────────────────────────────────────────
// const AddEditEquipment = () => {
//   const [equipmentData, setEquipmentData] = useState({
//     name_of_equipment: "",
//     date_of_purchase: "",
//     cost_of_equipment: "",
//     nameAndAddressOfSupplier: "",
//     date_of_manufacture: "",
//     date_of_installation: "",
//     department_where_intalled: "",
//     environmental_control: "",
//     spare_parts_inventory: "",
//     technical_manualCircuit_diagramLiterature: "",
//     after_sale_service_arrangement: "",
//     warranty_period: "",
//     life_of_equipment: "",
//     depreciation_per_year: "",
//   });

//   const { id } = useParams();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (id) {
//       const fetchEquipmentData = async () => {
//         try {
//           const data = await equipmentService.fetchAll();
//           const found = data.inventories.find((item) => item.id === parseInt(id));
//           if (found) setEquipmentData(found);
//         } catch (error) {
//           toast.error("Error fetching equipment data.");
//         }
//       };
//       fetchEquipmentData();
//     }
//   }, [id]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setEquipmentData({ ...equipmentData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const payload = {
//         name_of_equipment:                         equipmentData.name_of_equipment,
//         date_of_purchase:                          equipmentData.date_of_purchase,
//         cost_of_equipment:                         equipmentData.cost_of_equipment,
//         nameAndAddressOfSupplier:                  equipmentData.nameAndAddressOfSupplier,
//         date_of_manufacture:                       equipmentData.date_of_manufacture,
//         date_of_installation:                      equipmentData.date_of_installation,
//         department_where_intalled:                 equipmentData.department_where_intalled,
//         environmental_control:                     equipmentData.environmental_control,
//         spare_parts_inventory:                     equipmentData.spare_parts_inventory,
//         technical_manualCircuit_diagramLiterature: equipmentData.technical_manualCircuit_diagramLiterature,
//         after_sale_service_arrangement:            equipmentData.after_sale_service_arrangement,
//         warranty_period:                           equipmentData.warranty_period,
//         life_of_equipment:                         equipmentData.life_of_equipment,
//         depreciation_per_year:                     equipmentData.depreciation_per_year,
//       };

//       if (id) {
//         await equipmentService.update(id, payload);
//         toast.success("Equipment updated successfully!");
//       } else {
//         await equipmentService.create(payload);
//         toast.success("Equipment added successfully!");
//       }
//       navigate(-1);
//     } catch (error) {
//       toast.error("Error saving equipment.");
//     }
//   };

//   return (
//     <div className="bg-gray-50 flex items-start justify-center py-10 px-4">
//       <div className="w-full max-w-[1400px]">
//         <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">

//           {/* ── Header ── */}
//           <div className="bg-gray-800 px-8 py-5">
//             <h1 className="text-white text-[18px] font-[500] tracking-tight">
//               {id ? "Edit Equipment" : "Add Equipment"}
//             </h1>
//             <p className="text-gray-400 text-[12px] mt-0.5">
//               Fill in all fields to register the equipment maintenance record
//             </p>
//           </div>

//           <form onSubmit={handleSubmit}>
//             <div className="px-8 py-6">

//               {/* ── Section 1: Basic Info ── */}
//               <SectionLabel>Basic Information</SectionLabel>
//               <div className="grid grid-cols-2 gap-4">
//                 <InputField
//                   label="Name of Equipment"
//                   type="text"
//                   name="name_of_equipment"
//                   placeholder="e.g. MRI Machine"
//                   value={equipmentData.name_of_equipment}
//                   onChange={handleChange}
//                   required
//                 />
//                 <InputField
//                   label="Date of Purchase"
//                   type="date"
//                   name="date_of_purchase"
//                   value={equipmentData.date_of_purchase}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               <div className="grid grid-cols-2 gap-4 mt-4">
//                 <InputField
//                   label="Cost of Equipment"
//                   type="number"
//                   name="cost_of_equipment"
//                   placeholder="0"
//                   prefix="Rs."
//                   value={equipmentData.cost_of_equipment}
//                   onChange={handleChange}
//                   required
//                 />
//                 <InputField
//                   label="Name and Address of Supplier"
//                   type="text"
//                   name="nameAndAddressOfSupplier"
//                   placeholder="Supplier name & full address"
//                   value={equipmentData.nameAndAddressOfSupplier}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               {/* ── Section 2: Dates & Location ── */}
//               <SectionLabel>Dates & Location</SectionLabel>
//               <div className="grid grid-cols-3 gap-4">
//                 <InputField
//                   label="Date of Manufacture"
//                   type="date"
//                   name="date_of_manufacture"
//                   value={equipmentData.date_of_manufacture}
//                   onChange={handleChange}
//                   required
//                 />
//                 <InputField
//                   label="Date of Installation"
//                   type="date"
//                   name="date_of_installation"
//                   value={equipmentData.date_of_installation}
//                   onChange={handleChange}
//                   required
//                 />
//                 <InputField
//                   label="Department Where Installed"
//                   type="text"
//                   name="department_where_intalled"
//                   placeholder="e.g. Radiology, ICU"
//                   value={equipmentData.department_where_intalled}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               {/* ── Section 3: Technical Details ── */}
//               <SectionLabel>Technical Details</SectionLabel>
//               <div className="grid grid-cols-2 gap-4">
//                 <InputField
//                   label="Environmental Control"
//                   type="text"
//                   name="environmental_control"
//                   placeholder="e.g. Air Conditioned, Humidity Controlled"
//                   value={equipmentData.environmental_control}
//                   onChange={handleChange}
//                   required
//                 />
//                 <InputField
//                   label="Spare Parts Inventory"
//                   type="text"
//                   name="spare_parts_inventory"
//                   placeholder="e.g. Available – Local / Import"
//                   value={equipmentData.spare_parts_inventory}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               <div className="grid grid-cols-2 gap-4 mt-4">
//                 <InputField
//                   label="Technical Manual / Circuit Diagrams / Literature"
//                   type="text"
//                   name="technical_manualCircuit_diagramLiterature"
//                   placeholder="e.g. Provided by Supplier"
//                   value={equipmentData.technical_manualCircuit_diagramLiterature}
//                   onChange={handleChange}
//                   required
//                 />
//                 <InputField
//                   label="After Sale Service Arrangement"
//                   type="text"
//                   name="after_sale_service_arrangement"
//                   placeholder="e.g. Annual Maintenance Contract"
//                   value={equipmentData.after_sale_service_arrangement}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               {/* ── Section 4: Financials & Lifespan ── */}
//               <SectionLabel>Financials & Lifespan</SectionLabel>
//               <div className="grid grid-cols-2 gap-4">
//                 <InputField
//                   label="Warranty Period"
//                   type="text"
//                   name="warranty_period"
//                   placeholder="e.g. 2 Years"
//                   value={equipmentData.warranty_period}
//                   onChange={handleChange}
//                   required
//                 />
//                 <InputField
//                   label="Life of Equipment"
//                   type="text"
//                   name="life_of_equipment"
//                   placeholder="e.g. 10 Years"
//                   value={equipmentData.life_of_equipment}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               <div className="grid grid-cols-1 gap-4 mt-4">
//                 <InputField
//                   label="Depreciation Per Year"
//                   type="number"
//                   name="depreciation_per_year"
//                   placeholder="0"
//                   prefix="Rs."
//                   value={equipmentData.depreciation_per_year}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               {/* ── Footer ── */}
//               <div className="border-t border-gray-100 mt-8 pt-6 flex items-center justify-between">
//                 <button
//                   type="button"
//                   onClick={() => navigate(-1)}
//                   className="text-[13px] text-gray-400 hover:text-gray-600 transition-colors font-[500]"
//                 >
//                   ← Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="bg-gray-800 hover:bg-gray-700 transition-colors text-white text-[13px] font-[500] px-6 py-2.5 rounded-lg"
//                 >
//                   {id ? "Update Equipment →" : "Save Equipment →"}
//                 </button>
//               </div>

//             </div>
//           </form>
//         </div>

//         <p className="text-center text-[12px] text-gray-400 mt-4">
//           All fields marked as required must be filled before saving.
//         </p>
//       </div>
//     </div>
//   );
// };

// export default AddEditEquipment;


/////////////////////////////////////////////// RESTRICTION CODE ABOVE ───────────────────────────────────────────

import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import equipmentService from "../../../Services/inventoryService";

// ── Reusable components ──────────────────────────────────────
const SectionLabel = ({ children }) => (
  <p className="text-[11px] uppercase tracking-widest font-[500] text-gray-400 mb-3 mt-6">
    {children}
  </p>
);

const InputField = ({ label, prefix, ...props }) => (
  <div className="flex flex-col gap-1">
    <label className="text-[12px] font-[500] text-gray-500">{label}</label>
    <div className="relative">
      {prefix && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[12px] text-gray-400">
          {prefix}
        </span>
      )}
      <input
        {...props}
        className={`w-full ${prefix ? "pl-8" : "px-3"} pr-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none hover:border-orange-200 focus:border-orange-400 focus:ring-2 focus:ring-orange-100`}
      />
    </div>
  </div>
);

// ── Main Component ───────────────────────────────────────────
const AddEditEquipment = () => {
  const [equipmentData, setEquipmentData] = useState({
    name_of_equipment: "",
    date_of_purchase: "",
    cost_of_equipment: "",
    nameAndAddressOfSupplier: "",
    date_of_manufacture: "",
    date_of_installation: "",
    department_where_intalled: "",
    environmental_control: "",
    spare_parts_inventory: "",
    technical_manualCircuit_diagramLiterature: "",
    after_sale_service_arrangement: "",
    warranty_period: "",
    life_of_equipment: "",
    depreciation_per_year: "",
  });

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const fetchEquipmentData = async () => {
        try {
          const data = await equipmentService.fetchAll();
          const found = data.inventories.find((item) => item.id === parseInt(id));
          if (found) setEquipmentData(found);
        } catch (error) {
          toast.error("Error fetching equipment data.");
        }
      };
      fetchEquipmentData();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEquipmentData({ ...equipmentData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        name_of_equipment:                         equipmentData.name_of_equipment || null,
        date_of_purchase:                          equipmentData.date_of_purchase || null,
        cost_of_equipment:                         equipmentData.cost_of_equipment || null,
        nameAndAddressOfSupplier:                  equipmentData.nameAndAddressOfSupplier || null,
        date_of_manufacture:                       equipmentData.date_of_manufacture || null,
        date_of_installation:                      equipmentData.date_of_installation || null,
        department_where_intalled:                 equipmentData.department_where_intalled || null,
        environmental_control:                     equipmentData.environmental_control || null,
        spare_parts_inventory:                     equipmentData.spare_parts_inventory || null,
        technical_manualCircuit_diagramLiterature: equipmentData.technical_manualCircuit_diagramLiterature || null,
        after_sale_service_arrangement:            equipmentData.after_sale_service_arrangement || null,
        warranty_period:                           equipmentData.warranty_period || null,
        life_of_equipment:                         equipmentData.life_of_equipment || null,
        depreciation_per_year:                     equipmentData.depreciation_per_year || null,
      };

      if (id) {
        await equipmentService.update(id, payload);
        toast.success("Equipment updated successfully!");
      } else {
        await equipmentService.create(payload);
        toast.success("Equipment added successfully!");
      }
      navigate(-1);
    } catch (error) {
      toast.error("Error saving equipment.");
    }
  };

  return (
    <div className="bg-gray-50 flex items-start justify-center py-10 px-4">
      <div className="w-full max-w-[1400px]">
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">

          {/* ── Header ── */}
          <div className="bg-gray-800 px-8 py-5">
            <h1 className="text-white text-[18px] font-[500] tracking-tight">
              {id ? "Edit Equipment" : "Add Equipment"}
            </h1>
            <p className="text-gray-400 text-[12px] mt-0.5">
              Fill in all fields to register the equipment maintenance record
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="px-8 py-6">

              {/* ── Section 1: Basic Info ── */}
              <SectionLabel>Basic Information</SectionLabel>
              <div className="grid grid-cols-2 gap-4">
                <InputField
                  label="Name of Equipment"
                  type="text"
                  name="name_of_equipment"
                  placeholder="e.g. MRI Machine"
                  value={equipmentData.name_of_equipment}
                  onChange={handleChange}
                />
                <InputField
                  label="Date of Purchase"
                  type="date"
                  name="date_of_purchase"
                  value={equipmentData.date_of_purchase}
                  onChange={handleChange}
                />
              </div>

              <div className="grid grid-cols-2 gap-4 mt-4">
                <InputField
                  label="Cost of Equipment"
                  type="number"
                  name="cost_of_equipment"
                  placeholder="0"
                  prefix="Rs."
                  value={equipmentData.cost_of_equipment}
                  onChange={handleChange}
                />
                <InputField
                  label="Name and Address of Supplier"
                  type="text"
                  name="nameAndAddressOfSupplier"
                  placeholder="Supplier name & full address"
                  value={equipmentData.nameAndAddressOfSupplier}
                  onChange={handleChange}
                />
              </div>

              {/* ── Section 2: Dates & Location ── */}
              <SectionLabel>Dates & Location</SectionLabel>
              <div className="grid grid-cols-3 gap-4">
                <InputField
                  label="Date of Manufacture"
                  type="date"
                  name="date_of_manufacture"
                  value={equipmentData.date_of_manufacture}
                  onChange={handleChange}
                />
                <InputField
                  label="Date of Installation"
                  type="date"
                  name="date_of_installation"
                  value={equipmentData.date_of_installation}
                  onChange={handleChange}
                />
                <InputField
                  label="Department Where Installed"
                  type="text"
                  name="department_where_intalled"
                  placeholder="e.g. Radiology, ICU"
                  value={equipmentData.department_where_intalled}
                  onChange={handleChange}
                />
              </div>

              {/* ── Section 3: Technical Details ── */}
              <SectionLabel>Technical Details</SectionLabel>
              <div className="grid grid-cols-2 gap-4">
                <InputField
                  label="Environmental Control"
                  type="text"
                  name="environmental_control"
                  placeholder="e.g. Air Conditioned, Humidity Controlled"
                  value={equipmentData.environmental_control}
                  onChange={handleChange}
                />
                <InputField
                  label="Spare Parts Inventory"
                  type="text"
                  name="spare_parts_inventory"
                  placeholder="e.g. Available – Local / Import"
                  value={equipmentData.spare_parts_inventory}
                  onChange={handleChange}
                />
              </div>

              <div className="grid grid-cols-2 gap-4 mt-4">
                <InputField
                  label="Technical Manual / Circuit Diagrams / Literature"
                  type="text"
                  name="technical_manualCircuit_diagramLiterature"
                  placeholder="e.g. Provided by Supplier"
                  value={equipmentData.technical_manualCircuit_diagramLiterature}
                  onChange={handleChange}
                />
                <InputField
                  label="After Sale Service Arrangement"
                  type="text"
                  name="after_sale_service_arrangement"
                  placeholder="e.g. Annual Maintenance Contract"
                  value={equipmentData.after_sale_service_arrangement}
                  onChange={handleChange}
                />
              </div>

              {/* ── Section 4: Financials & Lifespan ── */}
              <SectionLabel>Financials & Lifespan</SectionLabel>
              <div className="grid grid-cols-2 gap-4">
                <InputField
                  label="Warranty Period"
                  type="text"
                  name="warranty_period"
                  placeholder="e.g. 2 Years"
                  value={equipmentData.warranty_period}
                  onChange={handleChange}
                />
                <InputField
                  label="Life of Equipment"
                  type="text"
                  name="life_of_equipment"
                  placeholder="e.g. 10 Years"
                  value={equipmentData.life_of_equipment}
                  onChange={handleChange}
                />
              </div>

              <div className="grid grid-cols-1 gap-4 mt-4">
                <InputField
                  label="Depreciation Per Year"
                  type="number"
                  name="depreciation_per_year"
                  placeholder="0"
                  prefix="Rs."
                  value={equipmentData.depreciation_per_year}
                  onChange={handleChange}
                />
              </div>

              {/* ── Footer ── */}
              <div className="border-t border-gray-100 mt-8 pt-6 flex items-center justify-between">
                <button
                  type="button"
                  onClick={() => navigate(-1)}
                  className="text-[13px] text-gray-400 hover:text-gray-600 transition-colors font-[500]"
                >
                  ← Cancel
                </button>
                <button
                  type="submit"
                  className="bg-gray-800 hover:bg-gray-700 transition-colors text-white text-[13px] font-[500] px-6 py-2.5 rounded-lg"
                >
                  {id ? "Update Equipment →" : "Save Equipment →"}
                </button>
              </div>

            </div>
          </form>
        </div>

        <p className="text-center text-[12px] text-gray-400 mt-4">
          All fields are optional — empty fields will be saved as null.
        </p>
      </div>
    </div>
  );
};
export default AddEditEquipment;
